import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'slideshow',
  template: `
    <div class="doctarz-slideshow" [style.minHeight]="minHeight || '300px'">
      <div class="slideshow-wrapper" *ngIf="imageUrls && imageUrls.length > 0">
        <div class="slide-container">
          <img
            [src]="getCurrentImage()"
            alt="Slide image"
            class="slide-image"
            (error)="onImageError($event)"
          />
        </div>
        <button
          class="slide-btn slide-prev"
          *ngIf="showArrows && imageUrls.length > 1"
          (click)="prevSlide()"
        >&#10094;</button>
        <button
          class="slide-btn slide-next"
          *ngIf="showArrows && imageUrls.length > 1"
          (click)="nextSlide()"
        >&#10095;</button>
        <div class="slide-dots" *ngIf="imageUrls.length > 1">
          <span
            *ngFor="let img of imageUrls; let i = index"
            class="dot"
            [class.active]="i === currentIndex"
            (click)="goToSlide(i)"
          ></span>
        </div>
      </div>
      <div class="no-images" *ngIf="!imageUrls || imageUrls.length === 0">
        <img src="assets/images/noImage.png" alt="No image" style="max-width:100%; max-height:300px; object-fit: cover;" />
      </div>
    </div>
  `,
  styles: [`
    .doctarz-slideshow {
      position: relative;
      width: 100%;
      overflow: hidden;
      background: #f5f5f5;
    }
    .slideshow-wrapper {
      position: relative;
      width: 100%;
      height: 100%;
    }
    .slide-container {
      width: 100%;
      height: 100%;
    }
    .slide-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      min-height: inherit;
      max-height: 525px;
    }
    .slide-btn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background: rgba(0,0,0,0.4);
      color: white;
      border: none;
      padding: 10px 16px;
      font-size: 18px;
      cursor: pointer;
      z-index: 10;
      border-radius: 3px;
    }
    .slide-btn:hover { background: rgba(0,0,0,0.7); }
    .slide-prev { left: 10px; }
    .slide-next { right: 10px; }
    .slide-dots {
      position: absolute;
      bottom: 10px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      gap: 6px;
    }
    .dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: rgba(255,255,255,0.6);
      cursor: pointer;
      transition: background 0.3s;
    }
    .dot.active { background: white; }
    .no-images {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 200px;
    }
  `]
})
export class SlideshowComponent implements OnInit, OnDestroy {
  @Input() imageUrls: any[] = [];
  @Input() minHeight: string = '300px';
  @Input() showArrows: boolean = true;
  @Input() autoPlay: boolean = true;
  @Input() autoPlayWaitForLazyLoadImages: boolean = false;
  @Input() lazyLoad: boolean = false;
  @Input() enableZoom: boolean = false;
  @Input() zoomMax: number = 2;
  @Input() zoomStep: number = 0.5;
  @Input() height: string = '';
  @Input() fullscreen: boolean = false;
  @Input() gestureEnable: boolean = false;
  @Input() loop: boolean = true;
  @Input() stopAutoPlayOnSlide: boolean = true;

  currentIndex = 0;
  private timer: any;

  ngOnInit() {
    if (this.autoPlay && this.imageUrls && this.imageUrls.length > 1) {
      this.timer = setInterval(() => this.nextSlide(), 4000);
    }
  }

  ngOnDestroy() {
    if (this.timer) clearInterval(this.timer);
  }

  getCurrentImage(): string {
    if (!this.imageUrls || this.imageUrls.length === 0) return 'assets/images/noImage.png';
    const img = this.imageUrls[this.currentIndex];
    if (typeof img === 'string') return img;
    if (img && img.url) return img.url;
    if (img && img.image) return img.image;
    return 'assets/images/noImage.png';
  }

  nextSlide() {
    if (this.imageUrls && this.imageUrls.length > 0) {
      this.currentIndex = (this.currentIndex + 1) % this.imageUrls.length;
    }
  }

  prevSlide() {
    if (this.imageUrls && this.imageUrls.length > 0) {
      this.currentIndex = (this.currentIndex - 1 + this.imageUrls.length) % this.imageUrls.length;
    }
  }

  goToSlide(index: number) {
    this.currentIndex = index;
  }

  onImageError(event: any) {
    event.target.src = 'assets/images/noImage.png';
  }
}

@Component({ selector: 'app-slideshow-placeholder', template: '' })
export class SlideshowPlaceholderComponent {}
